<template>
  <transition name="slideUp">
    <div id="place-info" v-if="active">
      <div class="place__header">
        <div class="place__header-content">
          <h1 class="header__title">
            <img v-if="place.icon" :src="place.icon" alt="">
            <img v-else :src="iconUrl" alt="">
            {{place.name}}
          </h1>
        </div>
        <ul class="group-buttons">
          <li>
            <button @click="expandPlaceInfo">
              <svg v-if="expand" class="icon icon-reduce" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-reduce"></use>
              </svg>
              <svg v-else class="icon icon-expand" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-expand"></use>
              </svg>
            </button>
          </li>
          <li>
            <button @click="closePlaceInfo">
              <svg class="icon icon-close" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>
              </svg>
            </button>
          </li>
        </ul>
      </div>
      <div class="place__content" v-show="expand">
        <div class="place__description" v-html="place.content"></div>
        <div class="place__tools">
          <div class="section">
            <div class="section__title">
              <span>Outils</span>
            </div>
            <button @click="proximityClick">
              <svg class="icon icon-map" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-map"></use>
              </svg>
              A proximité
            </button>
            <button @click="routeClick">
              <svg class="icon icon-compass" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-compass"></use>
              </svg>
              Itinéraire
            </button>
            <button @click="contactClick">
              <svg class="icon icon-bubble" aria-hidden="true" role="img">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-bubble"></use>
              </svg>
              Remarques
            </button>
          </div>
        </div>
        <div class="place__footer" v-html="place.footer"></div>
      </div>
    </div>
  </transition>
</template>

<script>
  /* global cgy_vars */
  /* eslint no-undef: "error" */
  
  import store from '../store/store'
  import json from '../store/jsonUrl'

  export default {
    name: 'place-info',
    data () {
      return {
        active: false,
        expand: false,
        iconUrl: cgy_vars.defaultMarker,
        place: '',
        markers: [],
        proximity: '',
        route: '',
        contact: ''
      }
    },
    mounted () {
      // Iterate through components
      for (var i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].$options.name === 'proximity') {
          // attach click event listener on proximity button
          this.proximity = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'route') {
          // attach click event listener on route button
          this.route = this.$parent.$children[i]
        }
        if (this.$parent.$children[i].$options.name === 'contact') {
          // attach click event listener on contact button
          this.contact = this.$parent.$children[i]
        }
      }
    },
    methods: {
      markerOnClick: function (e) {
        let id = e.target.placeId
        // Close the proximity comp.
        if (this.proximity.circle !== '') {
          this.proximity.closeProximity(id)
        }
        this.getAllMarkers()
        // Center on clicked marker
        store.state.map.setView(e.latlng, 14)
        // Set opacity to all Marker
        if (this.markers.length > 1) {
          this.handleMarkerOpacity(id)
        }
        this.getClickedMarkerData(id)
      },
      getClickedMarkerData: function (id) {
        this.active = true
        this.expand = true
        if (store.cache.places[id] && store.cache.activate) {
          this.place = store.cache.places[id]
        } else {
          this.$http.get(`${json.url.place}&id=${id}`).then((response) => {
            this.place = response.data
            store.cache.places[id] = response.id
          }, (response) => {
            console.log('error', response)
          })
        }
      },
      getAllMarkers: function () {
        let layers = store.state.map._layers
        let that = this
        Object.keys(layers).forEach(function (key) {
          if (layers[key].placeId) {
            that.markers.push(layers[key])
          }
        })
      },
      handleMarkerOpacity: function (id) {
        if (id) {
          for (let i = 0; i < this.markers.length; i++) {
            if (this.markers[i].placeId !== id) {
              this.markers[i].setOpacity(0.5)
            } else {
              this.markers[i].setOpacity(1)
            }
          }
        } else {
          for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setOpacity(1)
          }
        }
      },
      closePlaceInfo: function () {
        this.active = false
        this.expand = false
        this.handleMarkerOpacity(null)
      },
      expandPlaceInfo: function () {
        this.expand = !this.expand
      },
      proximityClick: function () {
        this.closePlaceInfo()
        this.proximity.proximityOnClick(this.place)
      },
      routeClick: function () {
        this.closePlaceInfo()
        this.route.routeOnClick(this.place)
      },
      contactClick: function () {
        this.closePlaceInfo()
        this.contact.contactOnClick(this.place)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// PlaceInfo.vue?765bc188